import React from "react";
import ThemeToggle from "./ThemeToggle";
import NotificationBell from "./NotificationBell";
import { usePartner } from "../context/PartnerContext";

const Topbar = ({ onMenuClick }) => {
  const { appName } = usePartner();
  return (
    <header className="topbar">
      <div className="topbar-left" style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <button onClick={onMenuClick} className="mobile-hamburger" aria-label="Open menu">
          <svg width="22" height="22" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8">
            <line x1="3" y1="5" x2="17" y2="5"/>
            <line x1="3" y1="10" x2="17" y2="10"/>
            <line x1="3" y1="15" x2="17" y2="15"/>
          </svg>
        </button>
        <span className="topbar-brand">
          <span>{appName === "CrunchAlpha" ? (<>Crunch<span style={{color:"var(--accent)"}}>Alpha</span></>) : appName}</span>
        </span>
      </div>
      <div className="topbar-right" style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <NotificationBell />
        <ThemeToggle />
      </div>
    </header>
  );
};

export default Topbar;
